import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { createCallbackActionCreator } from '../../Stream/helpers';
export const initializeNetworkBar = createAction(`${actionKey}/INITIALIZE`, (networkBarData)=>networkBarData);
export const initialFetch = createAction(`${actionKey}/FETCH_INITIAL`, ()=>({}));
export const fetchMoreWatchedGroups = createCallbackActionCreator(`${actionKey}/FETCH_WATCHED_GROUPS`);
export const fetchMoreRecommendedGroups = createCallbackActionCreator(`${actionKey}/FETCH_RECOMMENDED_GROUPS`);
export const togglePinGroup = createAction(`${actionKey}/TOGGLE_PIN`, (groupId, isPinnedAfter)=>({
        groupId,
        isPinnedAfter
    }));
export const toggleWatchGroup = createAction(`${actionKey}/TOGGLE_WATCH`, (groupId, isWatchingAfter)=>({
        groupId,
        isWatchingAfter
    }));
export const unrecommendGroup = createAction(`${actionKey}/UNRECOMMEND`, (groupId)=>({
        groupId
    }));
export const markChannelAsRead = createAction(`${actionKey}/MARK_AS_READ`, (channel)=>({
        channel
    }));
/** change state and update backend */ export const updateNetworkBarSection = createAction(`${actionKey}/TOGGLE_SECTION`, (section, isFoldedNow)=>({
        isFoldedNow,
        section
    }));
/** change state without updating backend */ export const setNetworkBarSection = createAction(`${actionKey}/SET_SECTION`, (section, isFoldedNow)=>({
        isFoldedNow,
        section
    }));
